var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('SidbearSettingsGroup',{attrs:{"title":"Images","active":""}},[_c('image-upload',{staticClass:"mb-2",attrs:{"image":_vm.image,"no-delete":false,"disable-settigns":""}}),_c('div',{staticClass:"flex flex-column gap-2"},_vm._l((_vm.images),function(image,index){return _c('div',{key:index,staticClass:"flex items-center justify-between border rounded-[2px] h-[30px] w-full px-2"},[_c('div',{staticClass:"bg-danger h-[25px] w-[25px] bg-cover",style:({backgroundImage: `url(${image.src})`})}),_c('a',{staticClass:"text-gray-400",attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.removeImage(index)}}},[_c('i',{staticClass:"fa fa-trash"})])])}),0)],1),_c('SidbearSettingsGroup',{attrs:{"title":"Gallery"}},[_c('b-form-group',{attrs:{"label":"Columns"}},[_c('div',{staticClass:"flex items-center gap-[10px]"},[_c('vue-slider',{staticClass:"editor-slider-1 !w-[170px]",attrs:{"interval":1,"dot-size":17,"tooltip":"none","min":1,"max":10},model:{value:(_vm.section.options.content.gallery.rows),callback:function ($$v) {_vm.$set(_vm.section.options.content.gallery, "rows", $$v)},expression:"section.options.content.gallery.rows"}}),_c('LinkedControlItem',{staticClass:"d-block !w-[60px]",attrs:{"min":1,"max":10},model:{value:(_vm.section.options.content.gallery.rows),callback:function ($$v) {_vm.$set(_vm.section.options.content.gallery, "rows", $$v)},expression:"section.options.content.gallery.rows"}})],1)]),_c('sid-range-slider',{attrs:{"label":"Gap","rule-name":"gap","sid":`.--gallery-gap-${_vm.section.sid}`,"default-dimension":"px","dimensions":[]}})],1),_c('SidbearSettingsGroup',{attrs:{"title":"Border & Radius"}},[_c('rule-tabs',[_c('template',{slot:"Normal"},[_c('b-form-group',[_c('div',{staticClass:"flex items-center justify-between"},[_c('label',{staticClass:"pb-0"},[_vm._v("Border Type")]),_c('sid-select',{staticClass:"w-[118px]",attrs:{"sid":`.--${_vm.section.sid}-image`,"rule-name":"border-style","searchable":false,"options":[{label: 'Solid', value: 'solid'}, {label: 'Dashed', value: 'dashed'}, {label: 'Dotted', value: 'dotted'}, {label: 'Double', value: 'double'}, {label: 'Outset', value: 'outset'}]}})],1)]),_c('b-form-group',[_c('sid-linked-group',{staticClass:"!mb-[7px]",attrs:{"sid":`.--${_vm.section.sid}-image`,"label":"Border Width","rule-name":"border","angles":[
              {
                text: '',
                value: 'top-width'
              },
              {
                text: '',
                value: 'right-width'
              },
              {
                text: '',
                value: 'bottom-width'
              },
              {
                text: '',
                value: 'left-width'
              }
            ]}}),_c('div',{staticClass:"flex w-full justify-end"},[_c('sid-color',{attrs:{"sid":`.--${_vm.section.sid}-image`,"rule-name":"border-color"}})],1)],1),_c('sid-linked-group',{staticClass:"mb-0",attrs:{"label":"Radius","sid":`.--${_vm.section.sid}-image`,"rule-name":"border","angles":[
            {
              text: '',
              value: 'top-left-radius'
            },
            {
              text: '',
              value: 'top-right-radius'
            },
            {
              text: '',
              value: 'bottom-left-radius'
            },
            {
              text: '',
              value: 'bottom-right-radius'
            }
          ]}})],1),_c('template',{slot:"Hover"},[_c('b-form-group',[_c('div',{staticClass:"flex items-center justify-between"},[_c('label',{staticClass:"pb-0"},[_vm._v("Border Type")]),_c('sid-select',{staticClass:"w-[118px]",attrs:{"sid":`.--${_vm.section.sid}-image`,"rule-name":"border-style","searchable":false,"presudo":":hover","options":[{label: 'Solid', value: 'solid'}, {label: 'Dashed', value: 'dashed'}, {label: 'Dotted', value: 'dotted'}, {label: 'Double', value: 'double'}, {label: 'Outset', value: 'outset'}]}})],1)]),_c('b-form-group',[_c('sid-linked-group',{staticClass:"!mb-[7px]",attrs:{"sid":`.--${_vm.section.sid}-image`,"label":"Border Width","rule-name":"border","presudo":":hover","angles":[
              {
                text: '',
                value: 'top-width'
              },
              {
                text: '',
                value: 'right-width'
              },
              {
                text: '',
                value: 'bottom-width'
              },
              {
                text: '',
                value: 'left-width'
              }
            ]}}),_c('div',{staticClass:"flex w-full justify-end"},[_c('sid-color',{attrs:{"sid":`.--${_vm.section.sid}-image`,"presudo":":hover","rule-name":"border-color"}})],1)],1),_c('sid-linked-group',{staticClass:"mb-0",attrs:{"label":"Radius","sid":`.--${_vm.section.sid}-image`,"rule-name":"border","presudo":":hover","angles":[
            {
              text: '',
              value: 'top-left-radius'
            },
            {
              text: '',
              value: 'top-right-radius'
            },
            {
              text: '',
              value: 'bottom-left-radius'
            },
            {
              text: '',
              value: 'bottom-right-radius'
            }
          ]}})],1)],2)],1),_c('SidbearSettingsGroup',{attrs:{"title":"Transform"}},[_c('rule-tabs',{scopedSlots:_vm._u([{key:"Normal",fn:function(){return [_c('sid-transform',{attrs:{"sid":`.--${_vm.section.sid}-image`,"rule-name":"transform","section":_vm.section}})]},proxy:true},{key:"Hover",fn:function(){return [_c('sid-transform',{attrs:{"sid":`.--${_vm.section.sid}-image`,"rule-name":"transform","presudo":":hover","section":_vm.section}})]},proxy:true}])})],1),_c('SidbearSettingsGroup',{attrs:{"title":"Filters"}},[_c('rule-tabs',{scopedSlots:_vm._u([{key:"Normal",fn:function(){return [_c('sid-background-filters',{attrs:{"sid":`.--${_vm.section.sid}-image`,"rule-name":"filter"}})]},proxy:true},{key:"Hover",fn:function(){return [_c('sid-background-filters',{attrs:{"sid":`.--${_vm.section.sid}-image`,"presudo":":hover","rule-name":"filter"}})]},proxy:true}])})],1),(_vm.getOpenedItemObj.image)?_c('SidbearSettingsGroup',{attrs:{"title":"Click Action","content-class":"min-h-[500px]"}},[_c('ButtonAction',{staticClass:"mb-0",attrs:{"config":_vm.getOpenedItemObj.image}})],1):_vm._e(),_c('SidbearSettingsGroup',{attrs:{"title":"Padding & Margins"}},[_c('sid-linked-group',{attrs:{"label":"Padding","sid":`.--gallery-container-${_vm.section.sid}`,"rule-name":"padding","min":0,"angles":[
        {
          text: '',
          value: 'top'
        },
        {
          text: '',
          value: 'right'
        },
        {
          text: '',
          value: 'bottom'
        },
        {
          text: '',
          value: 'left'
        }
      ]}}),_c('sid-linked-group',{attrs:{"label":"Margin","sid":`.--gallery-container-${_vm.section.sid}`,"rule-name":"margin","min":-2000,"max":2000,"angles":[
        {
          text: '',
          value: 'top'
        },
        {
          text: '',
          value: 'right'
        },
        {
          text: '',
          value: 'bottom'
        },
        {
          text: '',
          value: 'left'
        }
      ]}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }